import "./TableFill.scss";

interface IProps {}

export default function TableRowFill(props: IProps) {
    return <div className="userful-table-row-fill-cell" />;
}
